import { theme } from '@theme';
import { dvh } from '@barracuda/shared/utils/styles';

export const SideBarNavigationMobile = (isLoggedIn: boolean) => ({
  display: 'block',
  padding: '16px',
  '.MuiPaper-root': {
    zIndex: '1500',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: isLoggedIn ? '60%' : '100%',
    padding: isLoggedIn ? 'unset' : '16px',
    paddingTop: isLoggedIn ? '45px' : '16px'
  },
  '@media only screen and (min-width: 1080px)': {
    display: 'none'
  }
});

export const DashboardListItem = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '12px',
  color: theme.palette.common.darkGrey7,
  cursor: 'pointer',
  'img, svg': {
    marginBottom: '10px'
  },
  svg: {
    fill: theme.palette.common.black
  }
};
export const DashboardMobileListItem = {
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  color: theme.palette.common.darkGrey2,
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: 1.1,
  'img, svg': {
    marginBottom: '10px'
  },
  svg: {
    fill: theme.palette.common.black
  }
};

export const DashboardOutlet = {
  paddingLeft: '100px',
  marginTop: 0,
  height: '100%',
  width: '100%',
  minHeight: dvh(100),
  '@media only screen and (max-width: 1080px)': {
    padding: 0
  }
};
export const LogoutMobileBox = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const sideBarButtons = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '16px',
  gap: '16px',
  borderBottom: `1px solid ${theme.palette.common.lightGrey14}`,
  paddingBottom: '16px'
};
